import { render, staticRenderFns } from "./businessInfor.vue?vue&type=template&id=7212b473"
import script from "./businessInfor.vue?vue&type=script&lang=js"
export * from "./businessInfor.vue?vue&type=script&lang=js"
import style0 from "./businessInfor.vue?vue&type=style&index=0&id=7212b473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports